module.exports = __webpack_public_path__ + "static/media/gem.a931709a.svg";